module.exports = __webpack_public_path__ + "img/logo.0702ca34.png";